function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useRef, useImperativeHandle, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import InputContainer from './InputContainer';
import InputLabel from './InputLabel';
import InputHelper from './InputHelper';
import StyledInput from './StyledInput';
import Alert from '../Alert';
var Input = forwardRef(function (props, ref) {
  var theme = props.theme,
      mini = props.mini,
      label = props.label,
      mandatory = props.mandatory,
      id = props.id,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      unchangeable = props.unchangeable,
      icon = props.icon,
      iconAttrs = props.iconAttrs,
      helper = props.helper,
      error = props.error,
      onIconClick = props.onIconClick,
      displayOptionalLabel = props.displayOptionalLabel,
      rest = _objectWithoutPropertiesLoose(props, ["theme", "mini", "label", "mandatory", "id", "defaultValue", "disabled", "unchangeable", "icon", "iconAttrs", "helper", "error", "onIconClick", "displayOptionalLabel"]);

  var input = theme.input;
  var hasIcon = icon !== undefined;
  var hasError = error !== undefined && !disabled && !unchangeable;
  var inputRef = useRef({
    value: defaultValue
  });
  useImperativeHandle(ref, function () {
    return inputRef.current;
  });

  var _useState = useState(inputRef.current.value === undefined || inputRef.current.value === ''),
      isEmpty = _useState[0],
      setIsEmpty = _useState[1];

  var handleInput = function handleInput(e) {
    setIsEmpty(e.target.value.length === 0);
  };

  useEffect(function () {
    inputRef.current.addEventListener('input', handleInput);
    return function () {
      inputRef.current.removeEventListener('input', handleInput);
    };
  }, []);
  return /*#__PURE__*/React.createElement(InputContainer, {
    isMini: mini
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    ref: inputRef,
    id: id,
    isEmpty: isEmpty,
    hasError: hasError,
    hasIcon: hasIcon,
    defaultValue: defaultValue,
    disabled: disabled || unchangeable,
    isUnchangeable: unchangeable,
    "aria-invalid": hasError,
    "aria-describedby": hasError ? id + "-error" : undefined
  }, rest)), /*#__PURE__*/React.createElement(InputLabel, {
    id: id + "-label",
    htmlFor: id,
    hasIcon: hasIcon,
    hasError: hasError
  }, label, !mandatory && displayOptionalLabel && ' (optionnel)', icon && React.createElement(icon, _extends({
    id: id + "-icon",
    size: input.icon.size,
    onClick: onIconClick,
    tabIndex: onIconClick !== undefined ? 0 : undefined
  }, iconAttrs))), hasError && typeof error === 'string' && /*#__PURE__*/React.createElement(Alert, {
    id: id + "-error",
    mini: true,
    variant: "error",
    title: error
  }), helper && !unchangeable && /*#__PURE__*/React.createElement(InputHelper, {
    id: id + "-helper",
    hasIcon: hasIcon
  }, helper));
});
Input.displayName = 'Input';
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helper: PropTypes.string,
  icon: PropTypes.elementType,
  iconAttrs: PropTypes.shape({}),
  onIconClick: PropTypes.func,
  mandatory: PropTypes.bool,
  defaultValue: PropTypes.string,
  displayOptionalLabel: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  unchangeable: PropTypes.bool,
  mini: PropTypes.bool
} : {};
Input.defaultProps = {
  helper: undefined,
  icon: undefined,
  iconAttrs: undefined,
  onIconClick: undefined,
  mandatory: false,
  defaultValue: undefined,
  displayOptionalLabel: true,
  error: undefined,
  disabled: false,
  unchangeable: false,
  mini: false
};
export default withTheme(Input);